import {useState} from 'react';

export interface IUseMonitorModalState {
    isBatchMode: boolean,
    showToggle: boolean,
    toggleBatchMode: () => void,
    setShowResult: (_value: boolean) => void,
    handleCloseAndReset: () => void,
}

export const useMonitorModalState = (isNew: boolean, handleClose: () => void): IUseMonitorModalState => {
    const [isBatchMode, setIsBatchMode] = useState(false);
    const [showResult, setShowResult] = useState(false);

    const handleCloseAndReset = () => {
        handleClose();
        setIsBatchMode(false);
        setShowResult(false);
    };

    return {
        isBatchMode,
        showToggle: isNew && !showResult,
        toggleBatchMode: () => setIsBatchMode(prev => !prev),
        setShowResult,
        handleCloseAndReset,
    };
};

export default useMonitorModalState;
